'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getRoutingRules = require('./getRoutingRules');

var _MessageTypes = require('../../constants/MessageTypes');

var _getType = require('../../routing-rules/operators/getType');

var _RoutingTypes = require('../../routing-rules/constants/RoutingTypes');

var messageType = function messageType(message) {
  var routingRule = (0, _getRoutingRules.getRoutingRules)(message);
  var isBotsRule = (0, _getType.getType)(routingRule) === _RoutingTypes.BOT;

  return isBotsRule ? _MessageTypes.QUALIFIED_LEAD : _MessageTypes.TARGETED_MESSAGE;
};

exports.default = messageType;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/message/messageType.js
// module id = 918
// module chunks = 2 3